import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from "clsx";
import { useState } from "react";
import { useDisclosure } from "../utils";
import { Modal } from "./Modal";
import { Spinner } from "./Spinner";
export function VideoModal(param) {
    var youtubeVideoId = param.youtubeVideoId, _aspectRatio = param.aspectRatio, aspectRatio = _aspectRatio === void 0 ? 16 / 9 : _aspectRatio, _className = param.className, className = _className === void 0 ? "" : _className, _button = param.button, button = _button === void 0 ? /*#__PURE__*/ _jsx(PlayButton, {
        className: ""
    }) : _button;
    var ref = useDisclosure(), isOpen = ref.isOpen, onClose = ref.onClose, onOpen = ref.onOpen;
    var src = "https://www.youtube.com/embed/".concat(youtubeVideoId, "?vq=hd1080");
    var padding = 1 / aspectRatio * 100;
    var ref1 = useState(true), isLoading = ref1[0], setIsLoading = ref1[1];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Modal, {
                className: "!max-w-full mx-2 md:mx-20 " + className,
                content: /*#__PURE__*/ _jsxs("div", {
                    className: clsx("flex bg-white/20 text-white w-full flex-col items-center justify-center", "p-8 space-y-8"),
                    children: [
                        /*#__PURE__*/ _jsx(Modal.CloseButton, {
                            onClick: onClose
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "relative w-full max-h-[calc(80vh)]",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        paddingTop: padding + "%"
                                    }
                                }),
                                /*#__PURE__*/ _jsx("iframe", {
                                    title: "video",
                                    src: src,
                                    height: "1080",
                                    // width='1920'
                                    frameBorder: 0,
                                    // loading='lazy'
                                    allowFullScreen: true,
                                    allowTransparency: true,
                                    onLoad: function() {
                                        return setIsLoading(false);
                                    },
                                    className: "absolute bg-transparent rounded-lg inset-0 w-full h-full max-w-full"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: clsx("absolute inset-0 flex items-center justify-center", isLoading ? "block" : "hidden"),
                                    children: /*#__PURE__*/ _jsx(Spinner, {
                                        className: "text-5xl text-gray-600"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                isOpen: isOpen,
                onClose: onClose
            }),
            /*#__PURE__*/ _jsx("div", {
                onClick: onOpen,
                className: "",
                children: button
            })
        ]
    });
}
export function PlayButton(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("button", {
        className: "appearance-none ",
        children: /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
            viewBox: "0 0 24 24",
            className: clsx("h-28 hover:scale-110 transition-transform ", className)
        }, props), {
            children: /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M9.525 18.025q-.5.325-1.013.037Q8 17.775 8 17.175V6.825q0-.6.512-.888q.513-.287 1.013.038l8.15 5.175q.45.3.45.85t-.45.85Z"
            })
        }))
    });
}
VideoModal.PLayButton = PlayButton;
